<nav class="navbar navbar-dark navbar-expand-lg navbar-lg">
  <div class="container d-flex flex-column">
    <!-- FILA 1: LOGO + BOTONES -->
    <div class="d-flex justify-content-between align-items-center w-100">
      <!-- LOGO + TEXTO -->
      <a
        class="navbar-brand d-flex align-items-center"
        href="https://www.milicenciamedica.cl"
      >
        <svg width="151" height="34" viewBox="0 0 151 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_96_7945)">
                <path
                    d="M147.303 22.0902H139.182L133.26 5.09537H133.13L133.616 22.0902H129.053V0.322632H136.917L143 17.7367H143.129L142.645 0.322632H147.303V22.0902Z"
                    fill="currentColor" class="color-letra" />
                <path d="M118.82 22.0902H113.708V0.322632H118.82V22.0902Z" fill="currentColor" class="color-letra" />
                <path
                    d="M96.454 14.8988H94.5126V22.0902H89.4001V0.322632H96.454C101.049 0.322632 105.029 2.54776 105.029 7.3205C105.029 11.3838 101.922 14.8988 96.454 14.8988ZM99.5926 7.54624C99.5926 5.80484 98.4601 4.61165 96.3893 4.61165H94.5126V10.9646H96.3893C98.4601 10.9646 99.5926 9.41664 99.5926 7.54624Z"
                    fill="currentColor" class="color-letra" />
                <path
                    d="M70.3217 22.0902H63.2355L61.1323 11.7385C60.8411 10.2551 60.291 7.4495 59.9027 5.12762H59.7409L59.4821 22.0902H54.855L55.6963 0.322632H64.2386C64.2386 0.322632 66.2447 10.3518 67.2155 17.5109H67.3449C68.5745 10.3196 70.9689 0.322632 70.9689 0.322632H79.4141L80.2877 22.0902H74.3664L73.9781 5.12762H73.8163C73.3957 7.64299 72.878 10.1584 72.5221 11.7385L70.3217 22.0902Z"
                    fill="currentColor" class="color-letra" />
                <path
                    d="M46.5492 11.0289C46.5492 16.8658 44.5107 22.4126 36.842 22.4126C29.1733 22.4126 27.2319 16.8658 27.2319 11.0289C27.2319 5.35321 29.141 0 36.842 0C44.7049 0 46.5492 5.28872 46.5492 11.0289ZM41.1132 10.9967C41.1132 7.22361 40.2395 4.38577 36.842 4.38577C33.4445 4.38577 32.6356 7.28811 32.6356 10.9967C32.6356 15.1244 33.5093 18.1236 36.842 18.1236C40.1424 18.1236 41.1132 15.1566 41.1132 10.9967Z"
                    fill="currentColor" class="color-letra" />
                <path
                    d="M20.1872 20.0584C17.8576 21.6386 15.3013 22.4126 12.3891 22.4126C6.17657 22.4126 2.71436 18.5427 2.71436 11.0934C2.71436 4.45025 5.88536 0 12.3891 0C15.4955 0 18.2781 0.644967 20.1549 1.8704L18.2458 5.96593C17.1781 5.15972 15.3013 4.51475 13.004 4.51475C9.76823 4.51475 8.11801 6.54639 8.11801 11.0611C8.11801 15.8016 9.73587 17.8655 12.9392 17.8655C14.9454 17.8655 17.081 16.9625 18.5694 15.8984L20.1872 20.0584Z"
                    fill="currentColor" class="color-letra" />
                <path d="M62.5572 29.6145H0V33.9143H62.5572V29.6145Z" fill="#0F69C4" />
                <path d="M151 29.6145H62.5571V33.9143H151V29.6145Z" fill="#E22C2C" />
            </g>
            <defs>
                <clipPath id="clip0_96_7945">
                    <rect width="151" height="34" fill="white" />
                </clipPath>
            </defs>
        </svg>
        <div class="d-flex flex-column">
          <span>Subsecretaría de Salud Pública</span>
          <span>Ministerio de Salud</span>
        </div>
      </a>

      <!-- BOTONES UTILITARIOS + USUARIO -->
      <div class="d-flex align-items-center botones">
        <!-- Contraste -->
        <a href="#" (click)="toggleContrast($event)">
          <img
            src="assets/icons/header/boton_contraste.svg"
            alt="Contraste"
            style="height: 38px"
          />
        </a>

        <!-- Reducir texto -->
        <a
          href="#"
          (click)="decreaseFontSize($event)"
          [class.disabled]="isDecreaseDisabled()"
        >
          <img
            [src]="getDecreaseIcon()"
            alt="Reducir texto"
            style="height: 38px"
          />
        </a>

        <!-- Aumentar texto -->
        <a
          href="#"
          (click)="increaseFontSize($event)"
          [class.disabled]="isIncreaseDisabled()"
        >
          <img
            [src]="getIncreaseIcon()"
            alt="Aumentar texto"
            style="height: 38px"
          />
        </a>

        <!-- Iniciar sesión -->
        <button
          class="btn btn-primary d-flex align-items-center px-3 py-2"
          *ngIf="!isAuthenticated()"
          (click)="login()"
        >
          <img
            src="assets/svg/icons/icono_clave_unica.svg"
            alt="ClaveÚnica"
            style="height: 20px; margin-right: 8px"
          />
          Iniciar sesión
        </button>

        <!-- Usuario autenticado -->
        <div
          class="dropdown d-flex align-items-center"
          *ngIf="isAuthenticated()"
        >
          <a
            class="dropdown-toggle btn btn-secondary"
            href="#"
            id="userDropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span *ngIf="isAuthenticated()">{{ userName }}</span>
          </a>

          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="userDropdown"
          >
            <a class="dropdown-item" href="#" (click)="logout($event)"
              >Cerrar sesión</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Botón de menú (sidebar) -->
  <button class="btn" (click)="toggleSidebar()">
    <span><i class="bi bi-list"></i></span>
  </button>
</nav>
